import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { parseURLParams } from "../utils/helper";
import $ from "jquery";

export default function UserDetails() {
  const [stateList, setStateList] = useState([]);
  const [constituencyList, setConstituencyList] = useState([]);
  const [userDetails, setUserDetails] = useState({});
  const [userState, setUserState] = useState({ statename: "", stateid: "" });
  const [userConstituency, setUserConstituency] = useState({});
  const [userStateError, setUserStateError] = useState(false);
  const [userConstituencyError, setUserConstituencyError] = useState(false);

  const navigate = useNavigate();

  const getConstituencyList = (stateid, constituency_id) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append(
      "Cookie",
      "ADRUM_BT=R%3A0%7Cg%3Ad8d08cca-eed4-4913-bd71-af2f2bab06d76%7Cn%3Atmp_bjp_fb49d1de-d391-478a-ab5f-c84d7b25602e%7Ci%3A29063%7Cd%3A16%7Ce%3A168; NSC_10.10.24.75_443=ffffffff0902060845525d5f4f58455e445a4a423660"
    );

    var urlencoded = new URLSearchParams();
    urlencoded.append("action", "getconstituencylist");
    urlencoded.append(
      "token",
      "gKKZLKeV+7Qz8UpLR2loJ6/v0KyVSqbs+DI1KREOIOTkHwGWRvficfOsUa1joUPu"
    );
    urlencoded.append("deviceid", "ffffffff-cb11-0cb1-ffff-ffffd3f1ea4a");
    urlencoded.append("stateid", stateid);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch("https://api.narendramodi.in/apiv2", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (
          result &&
          (result._resultflag === 1 || result._resultflag === "1")
        ) {
          result.data.map((val, index) => {
            if (val.boothid == constituency_id) {
              let constituency_name = val.boothname;
              setUserConstituency({
                constituencyid: constituency_id,
                constituencyname: constituency_name,
              });
            }
          });

          setConstituencyList(result.data);
        }
      })
      .catch((error) => console.log("error", error));
  };

  const getStateList = (state_id) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append(
      "Cookie",
      "ADRUM_BT=R%3A0%7Cg%3Af136241d-f82c-4b34-9f04-a8956ebae07c3%7Cn%3Atmp_bjp_fb49d1de-d391-478a-ab5f-c84d7b25602e%7Ci%3A29062%7Cd%3A10%7Ce%3A101; NSC_10.10.24.75_443=ffffffff0902064045525d5f4f58455e445a4a423660"
    );

    var urlencoded = new URLSearchParams();
    urlencoded.append("action", "getstatelist");
    urlencoded.append(
      "token",
      "gKKZLKeV+7Qz8UpLR2loJ6/v0KyVSqbs+DI1KREOIOTkHwGWRvficfOsUa1joUPu"
    );
    urlencoded.append("deviceid", "ffffffff-cb11-0cb1-ffff-ffffd3f1ea4a");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch("https://api.narendramodi.in/apiv2", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (
          result &&
          (result._resultflag === 1 || result._resultflag === "1")
        ) {
          result.data.map((val, index) => {
            if (val.stateid == state_id) {
              let state_name = val.statename;
              setUserState({
                stateid: state_id,
                statename: state_name,
              });
            }
          });
          setStateList(result.data);
        }
      })
      .catch((error) => console.log("error", error));
  };

  const updateUserConstituencyDetails = (
    stateid,
    constituencyid,
    username,
    userid,
    userDetails
  ) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

    var urlencoded = new URLSearchParams();
    urlencoded.append("action", "updateuserconstituency");
    urlencoded.append("deviceid", "ffffffff-cb11-0cb1-ffff-ffffd3f1ea4a");
    urlencoded.append(
      "addressid",
      "5fd6fe5e04eca5ba546162658302a35c220796f6e424fe4fd273205028c0ddde"
    );
    urlencoded.append("state_id", stateid);
    urlencoded.append("constituency_id", constituencyid);
    urlencoded.append("apiversion", "2");
    urlencoded.append("user_name_display", username);
    urlencoded.append("userid", userid);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch("https://api.narendramodi.in/apiv2", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log("result", result);
        if (result && result._resultflag == 1) {
          localStorage.setItem("user", JSON.stringify(userDetails));
          navigate("/" + window.location.search);
        }
      })
      .catch((error) => console.log("error", error));
  };

  const proceedHandler = async () => {
    // console.log("clicked");
    let details = userDetails;
    details["state_id"] = userState["stateid"];
    details["state_name"] = userState["statename"];
    details["constituency_name"] = userConstituency["constituencyname"];
    details["user_constituency"] = userConstituency["constituencyid"];
    let jsonDetails = JSON.stringify(userDetails);
    localStorage.setItem("user", jsonDetails);
    var urlParams = parseURLParams(window.location.href);
    let user_id = "";

    try {
      let href = window.location.href;
      href = href.split("?userid=")[1];
      user_id = href.split("&")[0];
    } catch (error) { }

    // if (urlParams && urlParams["userid"]) {
    var userid =
      urlParams && urlParams["userid"]
        ? urlParams["userid"][0]
        : user_id
          ? user_id
          : "";

    let response = updateUserConstituencyDetails(
      userState["stateid"],
      userConstituency["constituencyid"],
      details["user_name_display"],
      userid,
      details
    );

    return;
    JSON.stringify(userDetails);

  };

  const getData = async (userid) => {
    var settings = {
      url: "https://api.narendramodi.in/apiv2",
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: {
        action: "userconstituency",
        addressid:
          "5fd6fe5e04eca5ba546162658302a35c220796f6e424fe4fd273205028c0ddde",
        deviceid: "ffffffff-cb11-0cb1-ffff-ffffd3f1ea4a",
        userid: userid,
        apiversion: "2",
      },
    };

    let res = await $.ajax(settings);
    // console.log(res);
    if (res && res._resultflag == 1) {
      let state_id = res.state_id;
      let constituency_id = res.constituency_id;

      let userconstituency = { state_id, constituency_id };
      let userD = localStorage.getItem("user");
      userD = JSON.parse(userD);
      setUserDetails(userD);
      getStateList(res.state_id);
      if (res.state_id) {
        getConstituencyList(res.state_id, res.constituency_id);
      }

      localStorage.setItem(
        "userconstituency",
        JSON.stringify(userconstituency)
      );

      if (state_id && constituency_id) {
        navigate("/" + window.location.search);
        // navigate("/userdetails" + window.location.search);
      } else {
        navigate("/userdetails" + window.location.search);
      }
    }
  };

  useEffect(() => {
    var urlParams = parseURLParams(window.location.href);
    let user_id = "";

    try {
      let href = window.location.href;
      href = href.split("?userid=")[1];
      user_id = href.split("&")[0];
    } catch (error) { }

    // if (urlParams && urlParams["userid"]) {
    var userid =
      urlParams && urlParams["userid"]
        ? urlParams["userid"][0]
        : user_id
          ? user_id
          : "";

    getData(userid);
  }, []);

  useEffect(() => {
    getConstituencyList(userState["stateid"]);
  }, [userState]);
  return (

    <>
      <div className="smajik_bg">
        <div className="container">
          
          <a href="#">
            <img src="/assets/images/backarrow.svg" className="img_arrow" alt="" />
          </a>
          <div className="smajik_banner smajik_banner2">

            <img src="/assets/images/img-31.jpg" alt="" />
          </div>
        </div>
      </div>
      <div className="landing_pge_wrap">
        <div className="container">
          <div className="landing_btm">
            <label className="loc_label">
              Please enter your state and constituency to proceed
            </label>

            <p className="landing_btm_p">
              Celebrating Beneficiary is connecting across the
              country. Tell us where are you organising yours:
            </p>
            <div className="drop_dadad">
              <select
                className="form-select1 userdtl_dropdownico"
                value={userState["stateid"]}
                onChange={(e) => {
                  // console.log('e', e.target.value)
                  e.target.value
                    ? setUserStateError(false)
                    : setUserStateError(true);
                  let get_val =
                    e.target.selectedOptions[0].getAttribute("data-name");
                  setUserState({
                    stateid: e.target.value,
                    statename: get_val,
                  });
                }}
              >
                <option value="">Select State</option>
                {stateList &&
                  stateList.length > 0 &&
                  stateList.map((state) => {
                    return (
                      <option
                        data-name={state["statename"]}
                        key={state.stateid}
                        value={state.stateid}
                      >
                        {state.statename}
                      </option>
                    );
                  })}
              </select>

              {userStateError && <p style={{ color: "red" }}>Please select a state</p>}
            </div>
            <div className="drop_dadad">
              {/* <div className="downwhiw_wrp">
              <img src="/assets/images/down_white.png" className="downwhiw" />
            </div> */}
              <select
                className="form-select1 userdtl_dropdownico "
                value={userConstituency["constituencyid"]}
                onChange={(e) => {
                  let get_val =
                    e.target.selectedOptions[0].getAttribute("data-name");
                  e.target.value
                    ? setUserConstituencyError(false)
                    : setUserConstituencyError(true);
                  setUserConstituency({
                    constituencyname: get_val,
                    constituencyid: e.target.value,
                  });
                }}
              >
                <option value="">Select Constituency</option>
                {constituencyList &&
                  constituencyList.length > 0 &&
                  constituencyList.map((data) => {
                    return (
                      <option
                        data-name={data.boothname}
                        key={data.boothid}
                        value={data.boothid}
                      >
                        {data.boothname}
                      </option>
                    );
                  })}
              </select>
              {userConstituencyError && (
                <p style={{ color: "red" }}>Please select a constituency</p>
              )}
            </div>
            <button
              onClick={() => proceedHandler()}
              className="btn_login martp20"
            >
              Proceed
            </button>
            {/* <button className="btn_login">Save</button> */}
          </div>
        </div>
      </div>
    </>
  );
}
